<template>
  <div class="comment">
    <div :class="`commentContent ${$isAdmin ? 'editable' : ''}`">
      <div class="commentAuthor">{{ comment.AuthorId }}</div>
      <div class="commentText">
        <p v-if="!editComment">{{ comment.Text }}</p>

        <EditForm
          v-if="editComment"
          :commentId="comment.Id"
          :editCommentText="comment.Text"
          @editComment="cancelEdit"
        ></EditForm>

        <div class="dropdown">
          <button
            v-if="$isAdmin"
            class="btn dropdown-toggle"
            @click="editMenuVisible = !editMenuVisible"
            :aria-label="kommentarMenyLabel"
            :aria-expanded="false"
            data-bs-toggle="dropdown"
            id="commentEditMenu"
          >
            <Icon :type="'edit'"></Icon>
          </button>

          <ul class="commentEditOptionList dropdown-menu" aria-labelledby="commentEditMenu">
            <li>
              <button
                class="btn commentEditOption d-flex align-items-center dropdown-item"
                @click="() => 
                  { 
                    editComment = !editComment; 
                    editMenuVisible = false; 
                  }
                "
              >
                <Icon :type="'edit'"></Icon>
                {{ $texter.redigera }}
              </button>
            </li>
            <li>
              <button
                class="btn commentEditOption d-flex align-items-center dropdown-item"
                @click="editMenuVisible = false"
                data-bs-toggle="modal"
                :data-bs-target="`#commentRemoveModal-${comment.Id}`"
              >
                <Icon :type="'cross'"></Icon>
                {{ $texter.taBort }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="created d-flex align-items-center">
      <Icon :type="'clock-o'"></Icon>
      <span>{{ comment.Created }}</span>
    </div>
  </div>
  
  <CommentRemove :commentId="comment.Id"></CommentRemove>
</template>

<script>
import Icon from "../../image/icon.vue";
import EditForm from "./editForm.vue";
import CommentRemove from "./commentRemove.vue";

export default {
  name: "Comment",
  props: {
    comment: Object,
  },
  data() {
    return {
      editComment: false,
      editMenuVisible: false,
    };
  },
  components: {
    Icon,
    EditForm,
    CommentRemove,
  },
  computed: {
    kommentarMenyLabel() {
      return this.$texter.kommentarMenyLabel.replace("{0}", this.comment.AuthorId);
    }
  },
  methods: {
    cancelEdit(value) {
      this.editComment = value;
    },
  }
};
</script>
